import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useRef } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import { useSectionRefs } from "../../../hooks/useSectionRefs";

const HelpTopicCreerPlanning = () => {
  const { windowWidth } = useContext(dataApplicationsContext);
  const { anchorsParts, topic, isLoading, LoadingComponent } = useSectionRefs();
  if (isLoading) return <LoadingComponent />;
  
  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'Gestion de votre compétition', link: '/topics/gestion-compet'},
    { label: "Général", link: '/topics/gestion-compet/general'}, 
    { label: topic.title, link: topic.link},
  ]

  // <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>dashboard</a>

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Depuis votre espace
              <a target='_blank' className="link" href={`${process.env.REACT_APP_FRONT_URL_APP}/app/dashboard`}>admin,</a> 
              cliquez sur l'onglet <strong>Planning.</strong><br/>
              C'est l'une des grandes forces de Wodzone : la gestion semi-automatique des plannings. Cela rend la planification de votre compétition beaucoup plus facile.
            </p>
            <TagsAnchorContainer parts={anchorsParts} legend='Dans cet article'/>
            <div className="article-container mt-40" ref={anchorsParts[0].ref}>
              <p className="help-title-part">{anchorsParts[0].content}</p>
              <p className="help-text">
                Commençons par définir un floor de compétition. Renseignez le nom du floor de compétition.
                <span className="fz-14 ml-8 op-9 fw-400">(par exemple, Floor Central)</span>, puis le nombre de ligne.
              </p>
              <p className="help-text">
                Si vous avez plusieurs floors, cliquez sur le bouton <span className="btn ml-8 mr-8">+ Ajouter le floor</span> puis saisissez à nouveau les informations.
              </p>
              <p className="help-text mt-24">
                Cliquez ensuite sur le bouton&nbsp;&nbsp;<strong>Enregistrer</strong>   pour valider votre ou vos floors.
              </p>
              <p className="help-text mt-24">
                <i className="bi bi-info-circle fz-18 mr-8"></i>
                Si le nombre de lignes peut varier d'un WOD à l'autre, ce n'est pas un problème. Vous pouvez commencer par renseigner le nombre de lignes 
                le plus commun à tous vos WODs. Vous pourrez l'ajuster facilement par la suite si nécessaire.
              </p>
            </div>
            <div className="article-container mt-56" ref={anchorsParts[1].ref}>
              <p className="help-title-part">{anchorsParts[1].content}</p>
              <p className="help-text">
                Un planning WOD est une expression pour désigner la création du planning d'un WOD précis.
              </p>
              <p className="help-text">
                Après avoir créé au moins un floor, le sous-menu <strong>Planning WODs</strong> apparaît dans la barre latérale 
                secondaire. Cliquez ensuite sur le bouton&nbsp;&nbsp;<strong>Ajouter un planning WOD</strong> pour ouvrir 
                le formulaire de saisie :
              </p>
              <div className="sub-article-container">
                <p className="help-text mb-8"><strong>Infos principales</strong></p>
                <ul className="mt-0">
                  <li className="pl-8 mb-8">
                    <p className="help-text">Saisissez le floor dans le menu de sélection</p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">Définissez précisément le nombre de lignes maximum sur le floor.</p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">Saisissez le nom du WOD</p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">La date et heure du briefing pour ce WOD</p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">La date et heure du début du WOD</p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Time Cap au format mm:ss. Ne saisissez seulement les chiffres.
                      &nbsp;&nbsp;<span className="fz-14 op-9 fw-400">(par exemple 14:00)</span>
                    </p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Temps de Transition entre 2 vagues au format mm:ss. Ne saisissez seulement les chiffres.
                      &nbsp;&nbsp;<span className="fz-14 op-9 fw-400">(par exemple 05:00)</span>
                    </p>
                  </li>
                  <li className="pl-8 mb-8">
                    <p className="help-text">
                      Ouverture du Warm-up : indiquez combien de temps, en minutes, les athlètes peuvent 
                      commencer à s'échauffer avant le début de leur vague.
                      &nbsp;&nbsp;<span className="fz-14 op-9 fw-400">(par exemple 30)</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Diffusion du Planning/WOD</strong></p>
                <p className="help-text">
                  Choisissez de publier immédiatement le WOD à vos athlètes ou planifiez sa diffusion en saisissant 
                  une date et une heure spécifiques.
                </p>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Choix des catégories</strong></p>
                <p className="help-text">
                  Cochez la ou les les catégories concernées par le Planning/WOD que vous configurez.
                </p>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Ordre de passage des catégories</strong></p>
                <p className="help-text">
                  <strong>L'ordre</strong> dans lequel vous sélectionnez les catégories est crucial, car il déterminera la manière dont 
                  les vagues seront créées. Vous pouvez facilement réorganiser l'ordre final en drag'n drop les cards grises.
                </p>
                <p className="help-text mb-8">
                  Vous pouvez ensuite choisir 3 options pour remplir vos vagues : <strong>Fin, Début ou Moyenne.</strong><br/>
                  Prenons un exemple. Une catégorie avec 40 participants, et un floor de 15 lignes :
                </p>
                <ul className="mt-0">
                  <li className="pl-8 mb-12">
                    <p className="help-text">
                      <strong className="mr-8">Fin : </strong>
                      La 1ère vague sera composée de 10 participants, tandis que les deux vagues suivantes seront remplies 
                      avec 15 participants chacune.
                    </p>
                  </li>
                  <li className="pl-8 mb-12">
                    <p className="help-text">
                      <strong className="mr-8">Début : </strong>
                      Les deux premières vagues seront complètes, avec 15 participants chacune, tandis que la dernière 
                      ne comportera que 10 participants.
                    </p>
                  </li>
                  <li className="pl-8 mb-12">
                    <p className="help-text">
                      <strong className="mr-8">Moyenne : </strong>
                      Les vagues seront réparties de manière homogène, avec un nombre de participants presque équivalent 
                      dans chaque vague. Par exemple, elles compteront respectivement 13, 13 et 14 participants.
                    </p>
                  </li>
                </ul>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Nombre de participants</strong></p>
                <p className="help-text">
                  Si vous souhaitez optimiser et créer précisément votre planning en fonction du nombre réel 
                  d'inscriptions des athlètes (par exemple, si toutes les places n'ont pas été vendues), activez le bouton
                  &nbsp;<i className="fz-14">"Choisir le nombre réel de participants inscrits"</i>.
                </p>
                <p className="help-text">
                  Sinon, indiquez le nombre de participants que vous souhaitez par catégorie. <br/>
                  Si l'on garde toujours notre exemple de 40 participants pour une catégorie, et que vous choisissez 
                  10 places pour ce WOD, seuls les 10 premiers participants au classement seront placés sur le planning. Utile
                  par exemple pour générer le planning de finale.
                </p>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Optimisation des Heats</strong></p>
                <ul className="mt-0">
                  <li className="pl-8 mb-12">
                    <p className="help-text">
                      <strong className="mr-8">Optimiser et remplir toutes les lignes à chaque heat : </strong>
                      Cela permet de compléter toutes les lignes de toutes les vagues, en ajoutant une deuxième catégorie 
                      sur le floor si nécessaire.
                    </p>
                    <p className="help-text">
                      <strong className="mr-8">Temps additionnel entre catégories (min) : </strong>
                      Par défaut, les intervalles de transition sont les mêmes entre les vagues, même lorsque vous passez 
                      d'une catégorie à l'autre. En définissant une valeur en minutes, vous pouvez ajouter un 
                      délais de transition supplémentaire entre 2 vagues de catégorie différentes. 
                      <span className="fz-14 ml-8 op-9 fw-400">(par exemple, pour modifier le matériel, poids sur le floor)</span>
                    </p>
                  </li>
                </ul>
              </div>
              <div className="sub-article-container mt-32">
                <p className="help-text mb-8"><strong>Calculer la fin du WOD</strong></p>
                <p className="help-text">
                  Une fois tous vos réglages renseignés, vous pouvez lancer une simulation de planning avant de le créer. 
                  Cela vous permettra d'évaluer les délais, les horaires des heats et d'estimer l'heure de fin du WOD. 
                  Cette simulation pourra vous aider à ajuster vos paramètres avant de finaliser la création du planning/WOD.
                  Cliquer pour cela sur&nbsp;&nbsp;<strong>Lancer la simulation</strong>
                </p>
              </div>
              <div className="article-container mt-56" ref={anchorsParts[2].ref}>
                <p className="help-title-part">{anchorsParts[2].content}</p>
                <p className="help-text">
                  Une fois tous les champs renseignés, cliquez sur le bouton <strong>Créer le planning</strong>.
                </p>
                <p className="help-text">
                  Pour modifier un planning/WOD déjà créé, cliquez sur son nom dans la barre latérale.
                  Un nouveau pannel s'ouvre dans l'écran principal. 
                  <a target='_blank' className="link" href={`#`}>Pour en savoir plus sue comment modifier un planning</a>
                </p>
              </div>
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCreerPlanning 